/* ============================================================
   Page width, set by what the view is showing.

   Three tools — the Licensing Navigator, the Postholder Planner and the
   SEZ / EPZ guide — put two quite different things on one route. First
   a chooser: three or four sibling paths, each a short card. Then, once
   you pick one, a checklist of steps with a sentence or two per step.

   Those want opposite widths, and the page could only have one. It had
   the reading measure, so the chooser rendered as three 640px cards
   stacked down the page with 740px of empty space beside them — and the
   page was 56% footer as a result, because there was so little else on
   it.

   Widening the page would have fixed the chooser and broken the
   checklist, which is the thing the reading measure was for. So the
   width follows the view instead: wide while you are choosing, narrow
   once you are reading.

   Not a general utility. Two states, three callers, and a route that
   genuinely changes shape — anywhere else, a page that cannot decide
   how wide it is usually wants splitting in two.
   ============================================================ */

/**
 * @param {Element} node  any element inside the page shell
 * @param {'wide'|'reading'} measure
 */
export function setPageMeasure(node, measure) {
  const page = node && node.closest('.page');
  if (!page) return;
  const wide = measure === 'wide';
  page.classList.toggle('container', wide);
  page.classList.toggle('container-narrow', !wide);
}
